import { SpeechBubbleText } from '@dreamstack/feature-components'
import type { BlockSpeechBubbleFragment } from '@dreamstack/investors-graphql'
import type { FunctionComponent } from 'react'
import tw from 'twin.macro'

const SpeechTriangle = tw.div`-translate-y-1/2 -rotate-45 left-[14px] w-0 h-0 border-b-accentroAquaLight-full border-b-[67px] border-l-[67px] border-l-transparent absolute`
export const DefaultSpeechBubble: FunctionComponent<React.PropsWithChildren<{
  block: BlockSpeechBubbleFragment
}>> = ({ block }) => {
  const textField = block.text

  return (
    <div tw="relative pb-px-48">
      <div tw="bg-accentroAquaLight-full flex items-center flex-nowrap p-px-40 w-full">
        <SpeechBubbleText>&ldquo;{textField}&rdquo;</SpeechBubbleText>
      </div>
      <SpeechTriangle />
    </div>
  )
}
